import React from 'react';
import Layout from '../dashboard/layouts/layout';
import DashboardSetting from '../dashboard/content/dashboard-setting';

function Dashboard() {
    return (
        <Layout>
            <DashboardSetting />
        </Layout>
    );
}

export default Dashboard;